<div mat-dialog-content>
  <div class="like-dislike-container" *ngIf="like_dislike_feedback">
    <div class="subtitle" mat-dialog-title>{{survey_question_dialog?.question_text}} </div>
    <div class="like-dislike-button-container">
      <button mat-raised-button><fa-icon [icon]="faThumbsDown" class="fa-4x dis-like" [fixedWidth]="true" (click)="thumb_click(false)"></fa-icon></button>
      <button mat-raised-button><fa-icon [icon]="faThumbsUp" class="fa-4x like" [fixedWidth]="true" (click)="thumb_click(true)"></fa-icon></button>
    </div>
  </div>
  <div class="like-dislike-container" *ngIf="show_feedback">
    <div class="subtitle" mat-dialog-title>Thanks for your feedback! Care to tell us why? </div>
    <textarea matInput type="text" [(ngModel)]="feedback_text" maxLength="500" placeholder="Enter your feedback here..." rows="5"></textarea>
    <mat-hint class="charlimit" >{{feedback_text?.length || 0}}/500</mat-hint>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [hidden]="!feedback_text" cdkFocusInitial (click)="submit_click()">Submit</button>
  <button mat-raised-button (click)="dismiss_click()">Dismiss</button>
</div>
